var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlugIn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    preserveAspectRatio: "xMidYMid meet",
    viewBox: "0 0 640 640",
    width: 640,
    height: 640,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M311.6 207.22C299.61 207.2 292.95 207.19 291.62 207.19C258.57 207.14 231.64 233.98 231.58 267.03C231.58 269.38 231.55 288.11 231.55 290.45C208.28 298.66 191.54 320.85 191.49 346.89C191.48 353.55 191.43 386.85 191.33 446.79C179.35 446.77 172.69 446.76 171.35 446.76C160.32 446.74 151.36 455.67 151.34 466.71C151.32 477.74 160.25 486.7 171.29 486.72C177.71 486.73 476.51 487.21 490.98 487.24C502.01 487.25 510.97 478.32 510.99 467.29C511 456.25 502.07 447.29 491.04 447.28C489.7 447.27 483.05 447.26 471.06 447.24C471.16 387.3 471.21 354 471.22 347.34C471.26 321.29 454.59 299.06 431.35 290.77C431.35 288.43 431.38 269.7 431.39 267.36C431.44 234.23 404.68 207.37 371.54 207.32C370.21 207.32 363.55 207.3 351.56 207.29C351.66 147.34 351.71 114.04 351.72 107.38C351.74 96.35 342.81 87.39 331.78 87.37C320.74 87.35 311.78 96.28 311.76 107.32C311.76 107.32 311.71 140.62 311.6 207.22ZM371.48 247.28C382.52 247.3 391.44 256.25 391.42 267.29C391.42 268.62 391.41 275.28 391.4 287.27L271.51 287.08C271.53 275.09 271.54 268.43 271.55 267.1C271.56 256.08 280.54 247.13 291.55 247.15C307.54 247.18 363.49 247.27 371.48 247.28ZM431.1 447.18L231.3 446.86C231.39 386.92 231.44 353.62 231.45 346.96C231.47 335.94 240.45 326.99 251.47 327.01C251.47 327.01 251.47 327.01 251.47 327.01C347.37 327.16 400.65 327.25 411.31 327.26C422.33 327.28 431.28 336.26 431.26 347.28C431.24 360.6 431.18 393.9 431.1 447.18Z",
    id: "c8sclcAJI"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c8sclcAJI",
    opacity: 1,
    fill: "#000000",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c8sclcAJI",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlugIn);
export default __webpack_public_path__ + "static/media/plugIn.60746eb2ae9971148547e8319871dc79.svg";
export { ForwardRef as ReactComponent };